/**
 * @cyntler/react-doc-viewer のレンダラー設定
 *
 * サーバーが適切なContent-Typeヘッダーを返さない場合（binary/octet-streamとして返す場合）でも、
 * Excel/Word/CSVファイルをプレビューできるようにするための設定。
 */
import MSDocRenderer from '@cyntler/react-doc-viewer/dist/esm/renderers/msdoc'
import CSVDocRenderer from '@cyntler/react-doc-viewer/dist/esm/renderers/csv'

/** binary/octet-stream MIMEタイプ */
const BINARY_OCTET_STREAM_MIME_TYPE = 'binary/octet-stream'

/** 登録済みフラグ（重複登録防止） */
let isRegistered = false

/**
 * MSDocRenderer と CSVDocRenderer に binary/octet-stream MIMEタイプのサポートを追加する
 *
 * この関数を呼び出すことで、サーバーが適切なContent-Typeを返さない場合でも
 * Excel(.xlsx, .xls)、Word(.docx, .doc)、CSV(.csv)ファイルをプレビューできるようになる。
 *
 * 重複登録を防ぐため、2回目以降の呼び出しは何もしない。
 */
export function registerBinaryOctetStreamSupport(): void {
  if (isRegistered) {
    return
  }

  MSDocRenderer.fileTypes.push(BINARY_OCTET_STREAM_MIME_TYPE)
  CSVDocRenderer.fileTypes.push(BINARY_OCTET_STREAM_MIME_TYPE)

  isRegistered = true
}
